import { Component, Input } from '@angular/core';

@Component({
  selector: 'vf-contributor-stack',
  templateUrl: './contributor-stack.component.html',
})
export class ContributorStackComponent {
  @Input() contributors: any[] = [];
  @Input() maxVisible: number = 3;
  @Input() emptyLabel: string = '';
  @Input() showFirstName: boolean = true;
  @Input() size: 'sm' | 'md' = 'md';

  get visibleContributors(): any[] {
    let list: any[] = [];

    if (!this.contributors || this.contributors.length === 0) {
      return list;
    }
    list = this.contributors.slice(0, this.maxVisible);
    return list;
  }

  get overflowCount(): number {
    let count: number = 0;

    if (!this.contributors) {
      return count;
    }
    count = this.contributors.length - this.maxVisible;
    return count > 0 ? count : 0;
  }

  get firstName(): string {
    let name: string = '';

    if (!this.contributors || this.contributors.length === 0) {
      return name;
    }
    name = this.getName(this.contributors[0]);
    return name;
  }

  getInitials(contributor: any): string {
    let initials: string = '';
    let source: string = '';

    if (!contributor) {
      return initials;
    }
    source = this.getName(contributor);
    if (!source) {
      return initials;
    }
    // Contributor avatars always use a single-character initial.
    initials = source.trim().charAt(0).toUpperCase();
    return initials;
  }

  getName(contributor: any): string {
    let name: string = '';

    if (!contributor) {
      return name;
    }
    // Backend `TaskContributorDto` sends first and last name separately.
    const first: string = contributor.name || contributor.userName || contributor.fullName || '';
    const last: string = contributor.surname || '';
    name = (first + (last ? ' ' + last : '')).trim();
    return name;
  }
}
